import * as React from "react";
import type { SVGProps } from "react";
const SvgFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 16"
    {...props}
  >
    <path
      fill="#333"
      fillRule="evenodd"
      d="M6.398 3.315c0 1.556-1.282 2.817-2.866 2.817C1.95 6.132.667 4.87.667 3.315.667 1.761 1.95.5 3.532.5c1.584 0 2.866 1.26 2.866 2.815m9.68-1.233c.692 0 1.255.553 1.255 1.233 0 .682-.563 1.235-1.255 1.235h-5.48a1.246 1.246 0 0 1-1.256-1.235c0-.68.563-1.233 1.256-1.233zM1.923 11.298h5.48c.693 0 1.256.553 1.256 1.235 0 .68-.563 1.234-1.256 1.234h-5.48a1.247 1.247 0 0 1-1.256-1.234c0-.682.563-1.235 1.256-1.235m12.545 4.017c1.583 0 2.865-1.261 2.865-2.816s-1.282-2.816-2.865-2.816-2.866 1.26-2.866 2.816 1.283 2.816 2.866 2.816"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFilterIcon;
